// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedPaymentStatus {
  extraPay: {"enum_constant":"extraPay"};
  extraPenalty: {"enum_constant":"extraPenalty"};
  none: {"enum_constant":"none"};
  pay: {"enum_constant":"pay"};
  penalty: {"enum_constant":"penalty"};
}

export type PaymentStatusId = keyof IParsedPaymentStatus;
export type PaymentStatusData = IParsedPaymentStatus[PaymentStatusId];
const data: PaymentStatusData[] = [{"enum_constant":"extraPay"},{"enum_constant":"extraPenalty"},{"enum_constant":"none"},{"enum_constant":"pay"},{"enum_constant":"penalty"}];
export default data;
